import React from "react";
import TransactionAddition from "./TransactionAddition";

const Transactions = (props) => {
  return (
    <>
      {props.panel && (
        <>
          <div
            id={"transactions-panel-" + props.id}
            className="inb-c-item-details inb-c-order-reservations row"
          >
            <TransactionAddition
              transactions={props.wallet.wallet_transactions}
              dispatch={props.data.dispatch}
            />
          </div>
        </>
      )}
      {!props.panel && (
        <TransactionAddition
          transactions={props.wallet.wallet_transactions}
          dispatch={props.data.dispatch}
        />
      )}
    </>
  );
};

export default Transactions;
